module.exports = __webpack_public_path__ + "static/Tech-mobile-51a2c6b80448c4410fb083663c96387b.png";